import { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { ConfigProvider } from "antd";
import Popup from "../../../Helpers/Popup/Popup";
import PopupTitle from "../../../Helpers/Popup/PopupParts/PopupTitle";
import Close from "../../../Helpers/CloseBtn/Close";
import Button from "../../../Helpers/Button/Button";
import trans, { isRTL } from "../../../../utils";
import { toast } from "react-toastify";
import { useCreateFormSubmissionVersionMutation, useGetSpecificFormQuery } from "../../../../Redux/service/Forms/Form";
import EditableFormFields from "./EditableFormFields";

export default function FormSubmissionVersionEditPopup({
  submission,
  onClose,
  onSuccess,
  zIndex = 1300,
}) {
  const modalRef = useRef(null);
  const [formData, setFormData] = useState(
    Array.isArray(submission?.formData) ? submission.formData : []
  );
  const { data: formDefinition, isLoading: isLoadingForm } = useGetSpecificFormQuery(
    submission?.formId || submission?.form?.id,
    { skip: !(submission?.formId || submission?.form?.id) }
  );
  const [createVersion, { isLoading }] = useCreateFormSubmissionVersionMutation();

  const handleSave = async () => {
    try {
      const result = await createVersion({
        id: submission.id,
        formData,
        status: submission.status,
      }).unwrap();

      toast.success(trans("Submission version created successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar",
      });

      onClose();
      if (onSuccess) {
        onSuccess(result?.data);
      }
    } catch (err) {
      toast.error(
        trans(err?.data?.message || "Failed to create submission version"),
        {
          autoClose: 2000,
          rtl: localStorage.getItem("lang") === "ar",
        }
      );
    }
  };

  if (!submission) return null;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0f6936",
          activeBg: "#0f6936",
          activeBorderColor: "#2e9245",
          zIndexPopupBase: 2000,
        },
      }}
      getPopupContainer={() => modalRef.current || document.body}
    >
      <Popup show={!!submission} zIndex={zIndex}>
        <div ref={modalRef} style={{ position: "relative" }}>
          <Modal.Header className="modal-header flex-between">
            <Modal.Title id="contained-modal-title-vcenter">
              <PopupTitle
                headtitle={trans("Edit Submission")}
                subtitle={submission.form?.name}
              />
            </Modal.Title>
            <Close
              // eslint-disable-next-line react/style-prop-object
              style="close-32 close"
              close={onClose}
              img="Close"
            />
          </Modal.Header>
          <Modal.Body
            className="modal-body-scrollable fixed-popup-height"
            style={{ overflowX: "hidden" }}
            dir={isRTL ? "rtl" : "ltr"}
          >
            {isLoadingForm ? (
              <div className="text-center p-3 text-muted">
                {trans("Loading form...")}
              </div>
            ) : (
              <EditableFormFields
                schemaFields={
                  submission.form?.formSchema?.fields ||
                  formDefinition?.data?.formSchema?.fields ||
                  submission.formData
                }
                valuesFields={submission.formData}
                onChange={setFormData}
              />
            )}
          </Modal.Body>
          <Modal.Footer>
            <div className="popups-footer gap-8">
              <Button
                type="primary"
                text={trans("Save Version")}
                htmlType="button"
                onClick={handleSave}
                loading={isLoading}
                disabled={isLoading}
              />
              <Button
                type="default"
                text={trans("Cancel")}
                htmlType="button"
                onClick={onClose}
              />
            </div>
          </Modal.Footer>
        </div>
      </Popup>
    </ConfigProvider>
  );
}
